import React from 'react';

const CryptoFuturesV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.3854 0.897805C10.2413 0.560269 9.76287 0.56027 9.61879 0.897805L8.90792 2.5632L7.13739 2.7645C6.78595 2.80445 6.64091 3.23644 6.89703 3.48038L8.23167 4.75157L7.86828 6.576C7.79755 6.9311 8.18211 7.20127 8.4922 7.01433L10.0021 6.10405L11.512 7.01433C11.8221 7.20127 12.2066 6.9311 12.1359 6.576L11.7725 4.75157L13.1072 3.48038C13.3633 3.23644 13.2182 2.80445 12.8668 2.7645L11.0963 2.5632L10.3854 0.897805Z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.33379 9.3771C7.52818 9.3771 6.87511 10.0302 6.87511 10.8358V13.5448H3.33173C2.52612 13.5448 1.87305 14.1979 1.87305 15.0035V17.5041C1.87305 18.3097 2.52612 18.9628 3.33173 18.9628L16.6689 18.9629C17.4745 18.9629 18.1276 18.3098 18.1276 17.5042V12.503C18.1276 11.6974 17.4745 11.0443 16.6689 11.0443H13.1266V10.8358C13.1266 10.0302 12.4735 9.3771 11.6679 9.3771H8.33379ZM11.8761 11.0443L11.8763 10.8358C11.8763 10.7207 11.783 10.6274 11.6679 10.6274H8.33379C8.21871 10.6274 8.12541 10.7207 8.12541 10.8358V17.7124H11.8761V11.0443ZM16.6689 17.7126H13.1266V12.2946H16.6689C16.784 12.2946 16.8773 12.3879 16.8773 12.503V17.5042C16.8773 17.6193 16.784 17.7126 16.6689 17.7126ZM3.12335 15.0035C3.12335 14.8884 3.21664 14.7951 3.33173 14.7951H6.87425V17.7125H3.33173C3.21665 17.7125 3.12335 17.6192 3.12335 17.5041V15.0035Z",
      fill: "#fff"
    }
  )
);

export { CryptoFuturesV2 };
//# sourceMappingURL=CryptoFuturesV2.js.map
